import { useEffect, useState } from "react";
import { Card, Spin } from "antd";
import { Bar } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../slice";
import * as selectors from "../selectors";

const OrderByStage = ({ selectedCommodities, dateRange }) => {
  const dispatch = useDispatch();

  const orderByStages = useSelector(selectors.selectOrderByStage);
  const [isLoading, setIsLoading] = useState(true);

  const stages = [
    { label: "Assigned", value: orderByStages?.assigned?.count || 0 },
    { label: "Accepted", value: orderByStages?.accepted?.count || 0 },
    { label: "Under Testing", value: orderByStages?.underTesting?.count || 0 },
    {
      label: "Report Uploaded",
      value: orderByStages?.reportUploaded?.count || 0,
    },
    { label: "Completed", value: orderByStages?.completed?.count || 0 },
    { label: "Under Dispute", value: orderByStages?.underDispute?.count || 0 },
    // { label: "Pending Registration", value: orderByStages?.pendingRegistration?.count || 0 },
    { label: "Rejected", value: orderByStages?.rejected?.count || 0 },
  ];

  const chartData = {
    labels: stages?.map((order) => order?.label),
    datasets: [
      {
        label: "Count",
        data: stages?.map((order) => order?.value),
        backgroundColor: "#8884d8",
      },
    ],
  };

  // Calculate dynamic step size based on max value
  const maxValue = Math.max(...stages?.map((stage) => stage?.value || 0).filter(value => value != null && value !== undefined));
  const dynamicStepSize = Math.max(10, Math.ceil(maxValue / 10) || 10);

  const chartOptions = {
    indexAxis: "x",
    responsive: true,
    maintainAspectRatio: false,
    animation: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: dynamicStepSize },
      },
    },
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      actions.getOrderByStage({
        selectedCommodities,
        dateRange,
        onSuccess: () => {
          setIsLoading(false);
        },
        onFailure: () => {
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, selectedCommodities, dateRange]);

  return (
    <Card
      title={
        <span style={{ color: "#000", fontWeight: 600, fontSize: 16 }}>
          Order By Stage
        </span>
      }
      headStyle={{
        backgroundColor: "#fff",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
      }}
      style={{
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      {isLoading ? (
        <div
          style={{
            minHeight: 652,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ marginBottom: 24 }}>
          <Bar data={chartData} options={chartOptions} height={652} />
        </div>
      )}
    </Card>
  );
};

export default OrderByStage;
